<template>
    <v-dialog v-model="dialog" width="70%" min-width="350px">
        <v-dialog :value="map" @input="map = false" lazy width="50%">
            <Map v-if="map" only-markers height="90vh" :appendMarkers="markers"/>
        </v-dialog>
        <v-card>
            <v-card-title primary-title class="title font-weight-bold">
                <v-btn v-if="step !== 1" icon @click="step--">
                    <v-icon color="primary">arrow_back</v-icon>
                </v-btn>
                Change Booking Details
            </v-card-title>
            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
            <v-divider/>
            <v-card-text class="pa-0" v-if="!loading">
                <v-stepper v-model="step" style="width:100%">
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1">Select Action</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 2" step="2">Select Attributes</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 3" step="3">Approve Action</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-container>
                                <v-layout row justify-space-around>
                                    <v-flex xs2>
                                        <v-card hover @click="action = 'change-captain', step++">
                                            <v-img :src="captain_icon"/>
                                            <v-divider/>
                                            <v-card-title primary-title class="headline bold text-md-center">
                                                <u>Change Captain</u>
                                            </v-card-title>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs2 v-if="!!booking && booking.service.is_pooling">
                                        <v-card hover @click="action = 'join-booking', step++">
                                            <v-img :src="plus_icon"/>
                                            <v-divider/>
                                            <v-card-title primary-title class="headline bold text-md-center">
                                                <u> Join Booking</u>
                                            </v-card-title>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs2>
                                        <v-card hover @click="action = 'change-time', step++">
                                            <v-img :src="clock_icon"/>
                                            <v-divider/>
                                            <v-card-title primary-title class="headline bold text-md-center">
                                                <u>Change Time</u>
                                            </v-card-title>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs2>
                                        <v-card hover @click="action = 'cancel-booking', step++">
                                            <v-img :src="trash_icon"/>
                                            <v-divider/>
                                            <v-card-title primary-title class="headline bold text-md-center">
                                                <u>Cancel Booking</u>
                                            </v-card-title>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-layout row wrap>
                                <v-flex xs8>
                                    <div class="headline font-weight-bold">
                                        Action: <u>{{action}}</u> , Booking :
                                    </div>
                                </v-flex>
                                <v-flex xs4>
                                    <request-card
                                            v-if="!!booking"
                                            :show-update-time="action === 'change-time'"
                                            :item="booking"
                                            :hide-cancel="action !== 'cancel-booking'"
                                            hide-approve
                                            @reject="deletePressed"
                                            @updateTime="val => time = val"
                                            @map="map = true"
                                    />
                                    <v-checkbox color="orange" label="Captain Cancelled"
                                                v-model="captain_cancelled"/>

                                </v-flex>
                                <v-flex xs12>
                                    <template v-if="action === 'join-booking'">
                                        <v-form ref="form" style="width: 100%">
                                            <v-text-field
                                                    v-model="booking_to_join_id"
                                                    full-width min="1"
                                                    :disabled="disabled"
                                                    :rules="[v => !!v || 'This Field is Required']"
                                                    type='number'
                                                    label="Enter booking id to join booking with"/>
                                            <v-checkbox color="orange" label="Captain Cancelled"
                                                        v-model="captain_cancelled"/>

                                        </v-form>
                                    </template>
                                    <template v-else-if="action === 'change-captain'">
                                        <choose-captains-multi v-model="captain"
                                                               :multi="false"
                                                               return-object
                                                               :initial-search-params="captainSearchParams"
                                                               label="Choose Captain"/>

                                        <v-select
                                                label="Change-captain Reason"
                                                v-model="change_captain_reason_id"
                                                :items="change_captain_reasons"
                                                item-text="reason"
                                                item-value="id"
                                        ></v-select>

                                        <v-checkbox color="orange" label="Captain Cancelled"
                                                    v-model="captain_cancelled"/>
                                    </template>
                                </v-flex>
                                <v-flex xs12>
                                    <v-layout justify-end>
                                        <v-btn :loading="disabled" flat large color="primary" @click="step++">
                                            Next
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-card>
                                <v-card-title>
                                    <v-layout row wrap>
                                        <v-flex xs12 class="title">
                                            <template v-if="action === 'change-captain'">
                                                You want to change the captain to :
                                            </template>
                                            <template v-if="action === 'join-booking'">
                                                You want to join ride :
                                            </template>
                                            <template v-else-if="action === 'change-time'">
                                                You want to change the time to :
                                            </template>
                                            <template v-else-if="action === 'cancel-booking'">
                                                <template v-if="this.delete">
                                                    You Want to <b>cancel</b> this booking
                                                </template>
                                                <template v-else>
                                                    You <b>don't want</b> to cancel this booking
                                                </template>
                                            </template>
                                        </v-flex>
                                        <template v-if="action === 'change-captain' && !!captain">
                                            <v-flex xs6 class="headline font-weight-bold">
                                                Captain Name
                                            </v-flex>
                                            <v-flex xs6 class="headline">
                                                {{captain.first_name}} {{captain.last_name}}
                                            </v-flex>
                                            <v-flex xs6 class="headline font-weight-bold">
                                                Captain Number
                                            </v-flex>
                                            <v-flex xs6 class="headline">
                                                {{captain.username}}
                                            </v-flex>
                                        </template>
                                        <template
                                                v-if="(action === 'change-captain' || action === 'join-booking') && booking && booking.service.is_pooling">
                                            <v-checkbox v-model="update_all_other_rides"
                                                        label="Apply This to all bookings in same ride"
                                            />
                                        </template>
                                        <template v-if="action === 'cancel-booking'">
                                            <v-flex xs12 v-if="cancel_before_limit">
                                                <v-radio-group v-model="reason" column color="blue">
                                                    <v-radio
                                                            v-for="item in $store.state.user.settings.CANCEL_BEFORE_LIMIT_OPTIONS"
                                                            :label="item"
                                                            :value="item"
                                                            :key="item"
                                                    />
                                                    <v-radio label="Other"
                                                             value="other"
                                                    />
                                                </v-radio-group>
                                                <v-text-field v-if="reason === 'other'" label="Other" v-model="other"/>

                                            </v-flex>
                                            <v-flex xs12>
                                                <v-checkbox color="red" v-model="use_penalty" label="Apply Penalty">
                                                    <div slot="append" :class="{
                                                            'red': use_penalty,
                                                            'green': !use_penalty,
                                                            'pa-3': true,
                                                            'white--text': true
                                                        }">
                                                        <template v-if="use_penalty">
                                                            Penalty Will Be Applied if applicable
                                                        </template>
                                                        <template v-else>
                                                            No Penalty will be applied
                                                        </template>
                                                    </div>
                                                </v-checkbox>
                                            </v-flex>
                                        </template>
                                        <v-flex md12 sm12>
                                            <v-layout justify-end>
                                                <v-btn color="red" flat @click="$emit('input',false)">
                                                    No!, Get me out of here!
                                                </v-btn>
                                                <v-btn color="primary" flat @click="doAction">
                                                    Yes!,I'm sure i want to do this
                                                </v-btn>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card-title>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import plus_icon from "@/assets/plus_icon.jpg";
    import clock_icon from "@/assets/clock_icon.jpg";
    import trash_icon from "@/assets/trash_icon.jpg";
    import captain_icon from "@/assets/captain_icon.jpg";
    import ChooseRideComponent from "@/components/wasilni/input/ChooseRideComponent";
    import RequestsEditor from "@/components/RequestsEditor";
    import RequestCard from "@/components/wasilni/RequestCard";
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import Map from "@/views/monitoring/Map";
    import Mapbox from "mapbox-gl";
    import moment from "moment";

    export default {
        components: {ChooseCaptainsMulti, RequestCard, RequestsEditor, ChooseRideComponent, Map},
        props: {
            value: Number
        },
        watch: {
            value(val) {
                this.resetState(val);
                if (!val) return;
                this.dialog = false;
                if (!this.booking || this.booking.id.toString() !== val.toString())
                    this.loadBooking();
                this.resetState(val);
            },

            dialog(val) {
                if (val === false)
                    this.$emit('input', null);
            },
            step(val) {
                if (val === 3)
                    this.approveAttributes();
            }
        },
        mounted() {
            this.axios
                .get(
                    "captain/change_captain_reason",
                    {
                        params: {
                            all: true
                        }
                    }
                )
                .then((res) => {
                    this.change_captain_reasons = res.data.data;
                }).catch(err => console.log(err.message))
                .finally(() => this.loading = false);
        },
        computed: {
            cancel_before_limit() {
                const limitMinutes = this.$store.state.user.settings.CANCELLATION_TICKET_LIMIT_MINUTES;
                const deadline = moment().add('minutes', limitMinutes);
                return moment(this.booking.datetime) <= deadline;
            },
            markers() {
                const activeBooking = this.booking;
                if (!activeBooking) return [];
                const markers = [new Mapbox.Marker({
                    color: "#00ff0f",
                    symbol: 'S'
                }), new Mapbox.Marker({color: "#ff000f", symbol: 'E'})];
                markers[0].setLngLat(activeBooking.pick_up_location.coordinates);
                markers[1].setLngLat(activeBooking.pull_down_location.coordinates);
                return markers;
            },
            plus_icon() {
                return plus_icon;
            },
            clock_icon() {
                return clock_icon;
            },
            trash_icon() {
                return trash_icon;
            },
            captain_icon() {
                return captain_icon;
            },
            captainSearchParams() {
                if (this.booking) {
                    const params = new URLSearchParams();
                    params.append('service', this.booking.service_id);
                    params.append('state', 'approved');
                    return params;
                }
                return null;
            }
        },
        methods: {
            approveAttributes() {
                switch (this.action) {
                    case "change-ride":

                }
            },
            deletePressed() {
                this.delete = true;
                window.getApp.$emit("SHOW_TOAST", "Will Be Deleted!", "green");
            },
            doAction() {
                const updateAllOtherRides = this.update_all_other_rides;
                this.loading = true;
                if (this.action === 'join-booking' || this.action === 'change-captain') {
                    this.axios.put(this.api.ACTIONS.REDISPATCH_BOOKING(this.booking.id), {
                        update_all_other_rides: updateAllOtherRides,
                        ...(this.action === 'join-booking' ? {
                            booking_id: this.booking_to_join_id
                        } : {
                            captain_id: this.captain.id,
                            change_captain_reason_id: this.change_captain_reason_id
                        }),
                        captain_cancelled: this.captain_cancelled,
                    }).then(
                        () => {
                            window.getApp.$emit("SHOW_TOAST", "SAVED", "green");
                            this.$emit('input', null);
                            this.$emit('update');
                        }
                    ).catch(({response}) => {
                        window.getApp.$emit('SHOW_TOAST', response.data.message, 'red');
                    }).finally(
                        () =>
                            this.loading = false
                    )
                } else if (this.action === 'cancel-booking') {
                    if (!this.delete) {
                        this.loading = false;
                        this.$emit('input', null);
                        return;
                    }
                    const key = this.reason === 'other' ? 'other' : 'reason';
                    const params = new URLSearchParams();
                    params.append('use_penalty', this.use_penalty + 0);
                    params.append('captain_cancelled', this.captain_cancelled + 0);
                    this.axios.delete(this.api.ACTIONS.BOOKINGS + '/' + this.booking.id, {
                        data: {
                            [key]: this[key],
                        },
                        params
                    }).then(
                        () => {
                            window.getApp.$emit("SHOW_TOAST", "SAVED", "green");
                            this.$emit('input', null);
                            this.$emit('update');
                        }
                    ).catch(({response}) => {
                        window.getApp.$emit('SHOW_TOAST', response.data.message, 'red');
                    }).finally(
                        () => this.loading = false
                    )
                } else if (this.action === 'change-time') {
                    window.getApp.$emit("SHOW_TOAST", "SAVED", "green");
                    this.$emit('input', null);
                    this.loading = false;
                }
            },
            loadBooking() {
                this.loading = true;
                this.axios.get(this.api.ACTIONS.BOOKINGS + '/' + this.value)
                    .then(
                        ({data: {data: booking}}) => this.booking = booking
                    )
                    .catch(
                        () => {
                            // TODO HANDLE EXCEPTION
                        }
                    ).finally(() => this.loading = false);

            },
            resetState(value) {
                this.dialog = !!value;
                this.step = 1;
                this.delete = null;
                this.disabled = false;
                this.booking_to_join_id = null;
                this.captain = null;
                this.update_all_other_rides = false;
                this.map = false;
                this.delete = null;
            }
        },
        data() {
            return {
                loading: false,
                dialog: !!this.value,
                use_penalty: false,
                step: 1,
                action: '',// one of : {join-booking,change-captain,change-time,cancel-booking}
                booking: null,
                disabled: false,
                booking_to_join_id: null,
                captain: null,
                map: false,
                delete: null,
                time: null,
                update_all_other_rides: false,
                reason: null,
                other: null,
                captain_cancelled: false,
                change_captain_reason_id: null,
                change_captain_reasons: null
            }
        },
        name: "booking-editor"
    }
</script>

<style scoped>

</style>
